import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import HeaderWrapper from "./HeaderWrapper";
import Header from "./components/Header";
import DetailReviewed from "./components/DetailReviewed"

const SolicitorDocumentPage = (): ReactElement => (
    <>
        <HeadTag title="Document Viewer for Solicitor" />
        <HeaderWrapper Header={Header}>
        <DetailReviewed />
        </HeaderWrapper>
    </>
);

export default SolicitorDocumentPage;
